import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UmssAvatarComponent } from '../avatar/avatar.component';
import { UmssBadgeComponent } from '../badge/badge.component';
import { UmssIconComponent } from '../icon/icon.component';
import { UmssMenuGroupLabelComponent } from '../menu-group-label/menu-group-label.component';

import { SideNavItem, SideNavGroup, SideNavUser } from '@umss/shared/utils';
export type { SideNavItem, SideNavGroup, SideNavUser };

@Component({
  selector: 'umss-side-nav',
  standalone: true,
  imports: [
    CommonModule,
    UmssMenuGroupLabelComponent,
    UmssAvatarComponent,
    UmssBadgeComponent,
    UmssIconComponent
  ],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class UmssSideNavComponent {
  constructor() {}

  /** Content props */
  @Input() set groups(value: SideNavGroup[]) {
    this.filteredViews = value.filter(
      (group) => !group.items.every((item) => item.hidden)
    );
  }

  protected filteredViews: SideNavGroup[] = [];

  @Input() user?: SideNavUser;

  /** Variant props */
  @Input() profile: 'Contractor' | 'Facility' | 'Business Admin' | 'Corporate' =
    'Facility'; // Profile type

  /** Event outputs */
  @Output() itemClick = new EventEmitter<SideNavItem>();
  @Output() userClick = new EventEmitter<SideNavUser>();

  /** Event handlers */
  onItemClick(item: SideNavItem): void {
    if (item.disabled) return;

    // Update selected state - deselect all items first
    this.filteredViews.forEach((group) => {
      group.items.forEach((i) => (i.selected = false));
    });

    // Select the clicked item
    item.selected = true;

    this.itemClick.emit(item);
  }

  onUserProfileClick(): void {
    if (this.user) {
      this.userClick.emit(this.user);
    }
  }

  /** Helper to get profile color scheme */
  get profileClass(): string {
    switch (this.profile) {
      case 'Contractor':
        return 'profile-contractor';
      case 'Facility':
        return 'profile-facility';
      case 'Business Admin':
        return 'profile-business-admin';
      default:
        return 'profile-facility';
    }
  }
}
